class FenceBuilderNew extends HTMLElement {
  constructor() {
    super();
    this.mobileSummaryToogler = this.querySelector('[data-summary-toggle]');

    this.sectionId = this.getAttribute("data-id");
    this.modelSelect = this.querySelector("[data-model-select]");
    this.coatingSelect = this.querySelector("select.single-option-selector[name='color']");
    this.pfostenSelect = this.querySelector('select.single-option-selector[name="post"]');
    this.productsList = this.querySelector("[data-products-list]");
    this.customCoutingButtons = this.querySelectorAll('button.select-coating:not([special-color-opener-toogle])');
    this.labelCoating = this.querySelector('#selected-option-beschichtung');
    this.customPfostenButtons = this.querySelectorAll('.select-option-div.post');

    this.addToCartBtn = this.querySelector('.product-form__cart-submit');
    this.addToCartText = this.querySelector("[data-add-to-cart-text]");
    this.loader = this.querySelector("[data-loader]");

    this.boxes = this.querySelectorAll('[data-box]');
    this.boxes_toggle = this.querySelectorAll('[data-box-toggle]');
    this.products = window.fenceBuilder[this.sectionId];

    this.quantityBoxes = this.querySelectorAll('[data-quantity-box]');
    this.quantityInputs = this.querySelectorAll('.product-item__qty-input');

    // model
    const currentModel = this.initValues('model', this.modelSelect.value);
    this.selectedModel = currentModel
    this.modelSelect.value = currentModel;

    // coating
    const coating = this.initValues('coating', this.coatingSelect.value);
    this.selectedCoating = coating;
    this.customCoutingButtons.forEach(button => {
      if (button.getAttribute('data-value') === coating) {
        button.classList.add('selected');
        this.labelCoating.textContent = button.getAttribute('data-value');
      }
    });

    //boxes
    this.activeBoxes = [...this.boxes_toggle].reduce((acc, box) => {
      const box_index = box.getAttribute('data-box-toggle');
      const isActive = Boolean(this.initValues(`box-${box_index}`, null));

      if (isActive) {
        box.classList.add('active');
        acc.push(box_index);
      }

      return acc;
    }, []);

    //quantitites
    this.quantities = [...this.quantityInputs].map(input => {
      const quantityIndex = input.getAttribute('data-quantity');
      const quatityValue = this.initValues(`quantity-${quantityIndex}`, input.value);

      input.value = quatityValue;

      const minusButton = input.closest('[data-quantity-box]').querySelector('.product-item__qty-minus');
      if (quatityValue <= 0) {
        minusButton.setAttribute('disabled', 'disabled');
      }

      return quatityValue;
    });

    // pfosten
    const pfosten = this.initValues('pfosten', this.pfostenSelect.value);
    this.pfostenSelect.value = pfosten;
    this.selectedPfosten = pfosten;
    this.customPfostenButtons.forEach(button => {
      if (button.getAttribute('data-value') === pfosten) {
        button.classList.add('selected');
      }
    });

    // accesories
    this.additionalAccesories = this.querySelectorAll("[data-additional-checkbox]");

    this.render();
    this.initCoatingSidebar();
    this.initPfostenSelect();
    this.initInfoPopup("[data-total-length-overlay]", "[data-total-length-modal]", "[data-total-length-close]", "[data-info-total-length]");
    this.initInfoPopup("[data-post-overlay]", "[data-post-modal]", "[data-post-close]", "[data-info-post]");


    this.selectedVariants = this.getSelectedVariants();

    this.setAccessoriesAvailability();

    this.selectedAccesories = [...this.additionalAccesories].reduce((acc, checkbox) => {
      const isChecked = this.initValues(checkbox.name, checkbox.checked);

      if (isChecked) {
        checkbox.checked = true;

        return [...acc, ({
          name: checkbox.name,
          productName: checkbox.getAttribute('data-accessories-name'),
          price: parseFloat(checkbox.getAttribute('data-price')) || 0,
          variantId: checkbox.getAttribute('data-product-id') || null,
          for: checkbox.getAttribute('data-for')
        })];
      }
      return acc;
    }, []);

    this.pfostenList = this.getSelectedPfostenList();
    this.calculateSumData();
  }

  connectedCallback() {
    this.coatingSelect.addEventListener("change", (event) => {
      this.selectedCoating = event.target.value;
      this.updateQueryParams("coating", event.target.value);
      this.render();

      this.updateSelectedVariants();
    });

    this.modelSelect.addEventListener("change", (event) => {
      this.selectedModel = event.target.value;

      this.updateQueryParams("model", event.target.value);
      this.render();

      this.updateSelectedVariants();
    });

    this.boxes_toggle.forEach(box => {
      box.addEventListener('click', () => {
        const wrapper = box.closest('[data-box]');
        const input = wrapper.querySelector('input[data-quantity]'); 
        
        if (!input) {
          return;
        }

        const inputValue = input.value;
        const plusButton = wrapper.querySelector('.product-item__qty-plus');
        const boxIndex = box.getAttribute('data-box-toggle');

        if (inputValue == 0) {
          plusButton.click();

          return;
        }

        if (inputValue > 0 && box.classList.contains('active')) {
          box.classList.remove('active');

          this.updateQueryParams(`box-${boxIndex}`, null);
          this.updateSelectedVariants();
          return;
        }

        if (inputValue > 0 && !box.classList.contains('active')) {
          box.classList.add('active');
          this.updateQueryParams(`box-${boxIndex}`, 'active');
          this.updateSelectedVariants();

          return;
        }
      });
    })

    // handle quantity boxes
    this.quantityBoxes.forEach(box => {
      const plusButton = box.querySelector('.product-item__qty-plus');
      const minusButton = box.querySelector('.product-item__qty-minus');
      const input = box.querySelector('.product-item__qty-input');

      plusButton.addEventListener('click', () => {
        input.value = parseInt(input.value) + 1;
        input.dispatchEvent(new Event('change'));

        minusButton.removeAttribute('disabled');
      });

      minusButton.addEventListener('click', () => {
        if (input.value >= 1) {
          const newValue = input.value - 1;

          newValue === 0 ? minusButton.setAttribute('disabled', 'disabled') : minusButton.removeAttribute('disabled');
          input.value = newValue;
          input.dispatchEvent(new Event('change'));        
        }
      });
    });

    this.quantityInputs.forEach(input => {
      input.addEventListener('change', (event) => {
        const value = event.target.value;
        const quantityIndex = input.getAttribute('data-quantity');
        const boxWrapper = input
          .closest('.fence-configurator__box')
          .querySelector('[data-box-toggle]');

        const boxIndex = boxWrapper.getAttribute('data-box-toggle');
        
        Number(value) > 0 ? boxWrapper.classList.add('active') : boxWrapper.classList.remove('active');

        this.updateQueryParams(`box-${boxIndex}`, Number(value) > 0 ? 'active': null);
        this.updateQueryParams(`quantity-${quantityIndex}`, Number(value));
        this.updateSelectedVariants();
      });
    });

    this.pfostenSelect.addEventListener('change', (event) => {
      this.selectedPfosten = event.target.value;
      this.updateQueryParams("pfosten", event.target.value);

      this.updateSelectedVariants();
    });

    this.additionalAccesories.forEach((checkbox => {
      checkbox.addEventListener('change', (e) => {
        this.updateQueryParams(checkbox.name, e.target.checked);

        this.selectedAccesories = [...this.additionalAccesories].filter(checkbox => checkbox.checked).map(checkbox => {

        return ({
          name: checkbox.name,
          productName: checkbox.getAttribute('data-accessories-name'),
          price: parseFloat(checkbox.getAttribute('data-price')) || 0,
          variantId: checkbox.getAttribute('data-product-id') || null,
          for: checkbox.getAttribute('data-for')
          })  
        });

        this.updateSelectedVariants();
      });
    }));

    this.addToCartBtn.addEventListener('click', () => {
      this.addToCart();
    });

    this.mobileSummaryToogler.addEventListener('click', () => {
      this.mobileSummaryToogler.classList.toggle('open');
    });
  }

  activeAddToCartButton() {
    if (this.selectedVariants.length > 0) {
      this.addToCartBtn.removeAttribute('disabled');
      this.addToCartBtn.classList.remove('disabled');

      return;
    }

    this.addToCartBtn.setAttribute('disabled', 'disabled');
    this.addToCartBtn.classList.add('disabled');
  }

  initValues(key, fallback) {
    const queryParams = new URLSearchParams(window.location.search);
    return queryParams.get(key) || fallback;
  }

  addToCart() {
    const items = this.selectedVariants.map(varaint => ({
      id: varaint.variantId,
      quantity: varaint.quantity || 1
    }))

    const posts = this.getSelectedPfostenList().map(pfosten => ({
      id: pfosten.variant.id,
      quantity: pfosten.quantity || 1
    }));

    const accessories = this.getSelectedAccesoriesList().map(accessory => ({
      id: accessory.variandId,
      quantity: accessory.quantity
    }));

    const formData = {
      items: [...items, ...posts, ...accessories]
    };

    this._handleButtonLoadingState(true);

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then(data => {
        window.location.href = '/cart';

        this._handleButtonLoadingState(false);
      })
      .catch((error) => {
        console.error('Error:', error);

        this._handleButtonLoadingState(false);
      });
  }

  _handleButtonLoadingState(isLoading) {
    if (isLoading) {
      this.addToCartBtn.setAttribute("aria-disabled", true);
      this.addToCartText.classList.add("hide");
      this.loader.classList.remove("hide");

      if (window.ShopifyPaymentButton) {
        window.ShopifyPaymentButton.setAttribute("disabled", true);
      }

    } else {
      this.addToCartBtn.removeAttribute("aria-disabled");
      this.addToCartText.classList.remove("hide");
      this.loader.classList.add("hide");

      if (window.ShopifyPaymentButton) {
        window.ShopifyPaymentButton.removeAttribute("disabled");
      }
    }
  }

  initCoatingSidebar() {
   const specialColorOpener = this.querySelector('button[special-color-opener-toogle]');
   const specialColors = this.querySelector('.special-colors').querySelectorAll('button.select-coating');

   this.customCoutingButtons.forEach(button => {
      button.addEventListener('click', () => {
        const targetNativeOption = button.getAttribute('data-value');

        this.customCoutingButtons.forEach(btn => btn.classList.remove('selected'));

        button.classList.add('selected');
        this.coatingSelect.value = targetNativeOption;
        this.coatingSelect.dispatchEvent(new Event('change'));
        this.labelCoating.textContent = targetNativeOption;
      });
   });

   specialColorOpener.addEventListener('click', () => {
      const firstSpecialColor = [...specialColors].at(0);

      firstSpecialColor.click();
   })
  }

  initPfostenSelect() {
    this.customPfostenButtons.forEach(button => {
      button.addEventListener('click', () => {
        const targetNativeOption = button.getAttribute('data-value');

        this.customPfostenButtons.forEach(btn => btn.classList.remove('selected'));
        button.classList.add('selected');
        this.pfostenSelect.value = targetNativeOption;
        this.pfostenSelect.dispatchEvent(new Event('change'));
      });
    });
  }

  calculateSumData() {
    this.calculateTotalLength();
    this.displayProductList();
    this.displaySelectedCoating();
    this.displaySelectedPfosten();
    this.displaySelectedAccessories();
    this.countTotalPrice();
    this.activeAddToCartButton();
  }

  calculateTotalLength() {
    const totalItemsLength = this.selectedVariants.reduce((acc, variant) => {
      const productData = this.products.activeItems.find(product => product.variants.some(v => v.id === variant.variantId));
      const countOfItems = variant.quantity || 1;
      const width = productData.montage_data?.element_width.value || productData.variants.find(v => v.id === variant.variantId).montage_data?.element_width.value;
      const mounting_space_left = productData.montage_data?.mounting_space_left.value || productData.variants.find(v => v.id === variant.variantId).montage_data?.mounting_space_left.value;
      const mounting_space_right = productData.montage_data?.mounting_space_right.value || productData.variants.find(v => v.id === variant.variantId).montage_data?.mounting_space_right.value;

      const length = (width + mounting_space_left + mounting_space_right) * countOfItems;

      return acc + length
    }, 0);

    const selectedPfosten = this.getSelectedPfostenList();

    const totalPostsLength = selectedPfosten.reduce((acc, pfosten) => {
      const width = pfosten.product.montage_data?.element_width.value || 50

      const countOfItems = pfosten.quantity || 1;

      return acc + (width * countOfItems);
    }, 0);

    const totalLengthElement = this.querySelector('[data-total-length]');

    if (!totalLengthElement) {
      return;
    }

    const totalLength = totalPostsLength + totalItemsLength

    totalLengthElement.textContent = `${(totalLength/ 1000).toFixed(2)} m`;
  }

  displayProductList() {
    const productList = this.querySelector('[data-product-list]');

    if (!productList) {
      return;
    }

    productList.innerHTML = '';

    this.selectedVariants.forEach(variant => {
      const productData = this.products.activeItems.find(product => product.variants.some(v => v.id === variant.variantId));
      const width = productData.montage_data?.element_width.value || productData.variants.find(v => v.id === variant.variantId).montage_data?.element_width.value;
      const height = productData.montage_data?.element_height.value || productData.variants.find(v => v.id === variant.variantId).montage_data?.element_height.value;

      const li = document.createElement('li');
      li.textContent = `${variant.quantity} x ${productData.title} ${width / 10} cm x ${height / 10} cm`;
      productList.appendChild(li);
    });
  }

  getPostWidth(isTwoGate, countOfItems, totalSelectedTwoGates) {
    if (this.selectedPfosten === 'none' || !this.selectedPfosten) {
      return 0;
    }

    if (isTwoGate) {
      return 100 * 2 * countOfItems;
    }


    if (totalSelectedTwoGates > 0 && countOfItems > 0) {
      return 50 * (countOfItems);
    }

    return (countOfItems + 1) * 50
  }

  displaySelectedCoating() {
    const selectedCoatingElement = this.querySelector('[data-selected-coating]');
    const circleCoatingElement = this.querySelector('[data-coating-circle]');

    if (!selectedCoatingElement) {
      return;
    }

    selectedCoatingElement.textContent = this.selectedCoating || '';

    circleCoatingElement.classList.forEach(className => circleCoatingElement.classList.remove(className));

    if (this.selectedCoating.includes('RAL 9005')) {
      circleCoatingElement.classList.add('ral9005');
    } else if (this.selectedCoating.includes('RAL 7016')) {
      circleCoatingElement.classList.add('ral7016');
    } else if (this.selectedCoating.includes('RAL 6005')) {
      circleCoatingElement.classList.add('ral6005');
    } else if (this.selectedCoating.includes('RAL 9010')) {
      circleCoatingElement.classList.add('ral9010');
    } else if (this.selectedCoating.includes('Unbeschichtet') || this.selectedCoating.includes('traité') || this.selectedCoating.includes('finitura') || this.selectedCoating.includes('Ongecoat') || this.selectedCoating.includes('Uncoated')) {
      circleCoatingElement.classList.add('uncoated');
    } else if (this.selectedCoating.includes('Feuerverzinkt') || this.selectedCoating.includes('Galvanisé') || this.selectedCoating.includes('Zincatura') || this.selectedCoating.includes('verzinkt') || this.selectedCoating.includes('Galvanised')) {
      circleCoatingElement.classList.add('galvanized');
    } else if (this.selectedCoating.includes('anthrazit') || this.selectedCoating.includes('anthracite') || this.selectedCoating.includes('Verniciatura') || this.selectedCoating.includes('Poedercoating') || this.selectedCoating.includes('Powder Coating') || this.selectedCoating.includes('Powder Coated')) {
      circleCoatingElement.classList.add('anthrazit');
    }
  }

  getSelectedPfostenList() {
    const selectedVariantsNormalPost = this.selectedVariants.filter(variant => !variant.name.includes('Gate'));
    const gatePosts = this.selectedVariants.filter(variant => variant.name.includes('2W Gate'));
    const geteOnePosts = this.selectedVariants.filter(variant => variant.name.includes('1W Gate'));

    const pfostenToGate = gatePosts.reduce((acc, variant) => {
      const pfosten = this.getPfosten(variant);

      if (pfosten) {
        return [...acc, {
          product: pfosten.product,
          variant: pfosten.variant,
          quantity: variant.quantity * 2 || 1
        }]
      }

      return acc;
    }, []);

    const pfostenToOneGate = geteOnePosts.reduce((acc, variant) => {
      const pfosten = this.getPfosten(variant);
      if (pfosten) {
        return [...acc, {
          product: pfosten.product,
          variant: pfosten.variant,
          quantity: (variant.quantity * 2) - (gatePosts.at(0)?.quantity || 0)
        }]
      }

      return acc;
    }, []);

    const normalPost = this.getPfosten(selectedVariantsNormalPost[0]);
    const totalQuantityFances = selectedVariantsNormalPost.reduce((acc, variant) => acc + (variant.quantity || 1), 0);

    const sumQuantity = (gatePosts.length > 0 || geteOnePosts.length > 0) ? totalQuantityFances : totalQuantityFances + 1;

    const pfostenToNormalPost = normalPost ? [{
      product: normalPost.product,
      variant: normalPost.variant,
      quantity: sumQuantity
    }] : [];

    const pfostenList = [...pfostenToGate, ...pfostenToOneGate, ...pfostenToNormalPost];

    return pfostenList
  }

  getSelectedAccesoriesList() {
    const countOfFences = this.selectedVariants.filter(variant => variant.name.includes('Fence')).reduce((acc, variant) => acc + (variant.quantity || 1), 0);
    const countOfGates = this.selectedVariants.filter(varaint => varaint.name.includes('Gate')).reduce((acc, variant) => acc + (variant.quantity || 1), 0);

    const accesories = this.selectedAccesories.reduce((acc, accessory) => {
      const forTwoGate = accessory.for.includes('2wgate') && !accessory.for.includes('1wgate');
      const forOneAndTwoGate = accessory.for.includes('1wgate') && accessory.for.includes('2wgate');

      if (forTwoGate) {
        const countOfTwoGates = this.selectedVariants.filter(variant => variant.name.includes('2W Gate')).reduce((acc, variant) => acc + (variant.quantity || 1), 0);

        return [...acc, {
          productName: accessory.productName,
          quantity: countOfTwoGates,
          price: accessory.price,
          variandId: Number(accessory.variantId)
        }]
      }

      if (forOneAndTwoGate) {
        const countOfGates = this.selectedVariants.filter(variant => variant.name.includes('Gate') || variant.name.includes('1W Gate')).reduce((acc, variant) => acc + (variant.quantity || 1), 0);

        return [...acc, {
          productName: accessory.productName,
          quantity: countOfGates,
          price: accessory.price,
          variandId: Number(accessory.variantId)
        }]
      }

      return [...acc, {
        productName: accessory.productName,
        quantity: (countOfFences + countOfGates) * 4,
        price: accessory.price,
        variandId: Number(accessory.variantId)
      }]
    }, []);

    return accesories;
  }

  displaySelectedPfosten() {
    const pfostenTile = this.querySelector('[data-pfosten-tile]');
    const pfostenList = this.querySelector('[data-selected-pfosten]');
    
    if (!pfostenTile) {
      return;
    }

    pfostenList.innerHTML = '';

    const selectedPfosten = this.getSelectedPfostenList();

    selectedPfosten.forEach(pfosten => {
      const li = document.createElement('li');
      li.textContent = `${pfosten.quantity}x ${pfosten.product.title}`;
      pfostenList.appendChild(li);
    });
  }

  getPfosten(variant) {
    if (!variant) {
      return null;
    }

    const posts = this.products.activePosts;

    if (this.selectedPfosten === 'concrete' && variant.name.includes('1W Gate')) {
      const postProduct = posts.find(post => post.montage_data?.type === 'Concrete' && post.montage_data.post_type === '1W Gate');
      const variant = postProduct.variants.find(variant => variant.title.includes( this.selectedCoating));

      return {
        product: postProduct,
        variant: variant,
      }
    }

    if (this.selectedPfosten === 'fence' && variant.name.includes('1W Gate')) {
      const postProduct = posts.find(post => post.montage_data?.type === 'Fence' && post.montage_data.post_type === '1W Gate');
      const variant = postProduct.variants.find(variant => variant.title.includes( this.selectedCoating));
      return {
        product: postProduct,
        variant: variant,
      }
    }


    if (this.selectedPfosten === 'concrete' && variant.name.includes('2W Gate')) {
      const postProduct = posts.find(post => post.montage_data?.type === 'Concrete' && post.montage_data.post_type === 'Gate');
      const variant = postProduct.variants.find(variant => variant.title.includes( this.selectedCoating));

      return {
        product: postProduct,
        variant: variant,
      }
    }

    if (this.selectedPfosten === 'fence' && variant.name.includes('2W Gate')) {
      const postProduct = posts.find(post => post.montage_data?.type === 'Concrete' && post.montage_data.post_type === 'Gate');
      const variant = postProduct.variants.find(variant => variant.title.includes(this.selectedCoating));

      return {
        product: postProduct,
        variant: variant,
      }
    }

    if (this.selectedPfosten === 'fence' && variant.name.includes('Fence')) {
      const postProduct = posts.find(post => post.montage_data?.type === 'Fence' && post.montage_data.post_type === 'Universal');
      const variant = postProduct.variants.find(variant => variant.title.includes( this.selectedCoating));

      return {
        product: postProduct,
        variant: variant,
      }
    }

    if (this.selectedPfosten === 'concrete' && variant.name.includes('Fence')) {
      const postProduct = posts.find(post => post.montage_data?.type === 'Concrete' && post.montage_data.post_type === 'Universal');
      const variant = postProduct.variants.find(variant => variant.title.includes( this.selectedCoating));
      
      return {
        product: postProduct,
        variant: variant,
      }
    }

    return null;
  }

  displaySelectedAccessories() {
    const selectedAccesoriesElement = this.querySelector('[data-selected-accessories]');
    const accesoriesList = this.getSelectedAccesoriesList();

    selectedAccesoriesElement.innerHTML = '';

    accesoriesList.forEach(accessory => {
      const li = document.createElement('li');
      li.textContent = `${accessory.quantity}x ${accessory.productName}`;
      selectedAccesoriesElement.appendChild(li);
    });
  }

  countTotalPrice() {
    // normal items
    const allVariantsData = this.selectedVariants.reduce((acc2, selectedVariant) => {
      const variantData = this.products.activeItems.reduce((acc, product) => { 
        const variant = product.variants.find(v => v.id === selectedVariant.variantId);
    
        if (variant) {
          acc.push({
            product: product,
            variant: variant,
            quantity: selectedVariant.quantity || 1
          });
        }
    
        return acc;
      }, []);
    
      return [...acc2, ...variantData];
    }, []);

    // total Product Prices
    const { sumOfProductsPrice, sumOfCompareAtPrice } = allVariantsData.reduce(
      (acc, variantData) => {
        const price = variantData.variant?.price || 0;
        const compareAt = variantData.variant?.compare_at_price || price;
    
        acc.sumOfProductsPrice += price * variantData.quantity;
        acc.sumOfCompareAtPrice += compareAt * variantData.quantity;
    
        return acc;
      },
      {
        sumOfProductsPrice: 0,
        sumOfCompareAtPrice: 0
      }
    );

    // posts
    const selectedPosts = this.getSelectedPfostenList();

    const { totalPostPrice, totalCompareAtPostPrice } = selectedPosts.reduce((acc, pfosten) => {
      if (!pfosten || !pfosten.variant) return acc;

      const price = pfosten.variant.price || 0;
      const compareAt = pfosten.variant.compare_at_price || price;

      acc.totalPostPrice += price * pfosten.quantity;
      acc.totalCompareAtPostPrice += compareAt * pfosten.quantity;

      return acc;
    }, {
      totalPostPrice: 0,
      totalCompareAtPostPrice: 0
    });

    const selectedAccesories = this.getSelectedAccesoriesList();

    const pricesOfAccessories = selectedAccesories.reduce((acc, accessory) => {
      return acc + (accessory.quantity * (accessory.price || 0));
    }, 0)

    const totalPrice = sumOfProductsPrice + totalPostPrice + pricesOfAccessories;
    const totalCompareAtPrice = sumOfCompareAtPrice + totalCompareAtPostPrice + pricesOfAccessories;
    const totalPriceElement = this.querySelector('[data-total-price]');
    const totalPriceMobileElement = this.querySelector('[data-total-price-mobile]');

    if (!totalPriceElement) {
      return;
    }

    if (totalCompareAtPrice > totalPrice) {
      const compareAtPriceElement = document.createElement('span');
      compareAtPriceElement.classList.add('compare-at-price');
      compareAtPriceElement.textContent = theme.Currency.formatMoney(totalCompareAtPrice, theme.moneyFormat);

      totalPriceElement.textContent = theme.Currency.formatMoney(totalPrice, theme.moneyFormat);
      totalPriceElement.appendChild(compareAtPriceElement);

      totalPriceMobileElement.textContent = theme.Currency.formatMoney(totalPrice, theme.moneyFormat);
      totalPriceMobileElement.appendChild(compareAtPriceElement.cloneNode(true));

      return;
    }

    totalPriceElement.textContent =  theme.Currency.formatMoney(totalPrice, theme.moneyFormat);
    totalPriceMobileElement.textContent = theme.Currency.formatMoney(totalPrice, theme.moneyFormat);
  }

  render() {
    const modelProducts = this.products.activeItems.filter((product) => {
      return this.selectedModel == product.model;
    });

    const blockedVariants = ['kleiner','zwischen', 'moins', 'entre', '30 - 96', '96 - 192,5', '96 - 192.5'];

    const products = modelProducts.reduce((acc, product) => {
      const variants = product.variants.filter(variant => variant.options.includes(this.selectedCoating) && blockedVariants.every(blockedVariantnName => !variant.title.includes(blockedVariantnName)));

      return [...acc, {
        ...product,
        variants: variants,
        montageData: product.montageData
      }]
    }, []);

    const productsToIncject = products.flatMap(product => {
      return product.variants.map(variant => {
        const montage_width = product.montage_data?.element_width?.value ?? variant.montage_data?.element_width.value;
        const montage_height = product.montage_data?.element_height?.value ?? variant.montage_data?.element_height.value;
        const montage_unit = product.montage_data?.element_width.unit ?? variant.montage_data?.element_width.unit;

        const imageVariant = `<img class="product-item__image" src="${variant.image}" />`;

        const content = `
          <h3 class="product-item__title">${product.title}</h3>
            <p class="product-item__dimensions">${montage_width / 10} cm x ${montage_height / 10} cm</p>
        `

        const variantId = variant.id;

        return {
          variantId: variantId,
          imageHTML: imageVariant,
          contentHTML: content,
          type: product.montage_data?.type ?? 'Fence',
          name: product.montage_data?.name ?? 'Fence'
        }
      });
    });

    this.boxes.forEach((box, index) => {
      // protect
      if (!productsToIncject[index]?.variantId) {
        box.classList.add('hidden');

        return;
      }

      box.classList.remove('hidden');
      
      const imageWrapper = box.querySelector('.product-item__image-wrapper');
      const contentWrapper = box.querySelector('.product-item__content');

      imageWrapper.innerHTML = productsToIncject[index].imageHTML;
      box.setAttribute('data-variant-id', productsToIncject[index].variantId);
      box.setAttribute('data-montage-type', productsToIncject[index].type);
      box.setAttribute('data-montage-name', productsToIncject[index].name);
      
      contentWrapper.innerHTML = productsToIncject[index].contentHTML;
      box.classList.add('product-item');
    });
  }

  getSelectedVariants() {
    const selectedVariants = [...this.boxes].reduce((acc, box) => {
      const variantId = box.getAttribute('data-variant-id');
      const isSelected = Boolean(box.querySelector('.product-item__image-wrapper.active'));

      if (!isSelected || !variantId) {
        return acc;
      }

      const quantityInput = box.querySelector('.product-item__qty-input');
      const quantity = quantityInput ? parseInt(quantityInput.value) : 1;
      const type = box.getAttribute('data-montage-type');
      const name = box.getAttribute('data-montage-name');

      return [...acc, {
        variantId: Number(variantId),
        quantity: quantity,
        type: type,
        name: name
      }];
    }, []);

    return selectedVariants;
  }

  updateSelectedVariants() {
    this.selectedVariants = this.getSelectedVariants();

    this.setAccessoriesAvailability();
    this.calculateSumData();
  }

  updateQueryParams(key, value) {
    let url = new URL(window.location.href);
    if (!value || value === "none") {
      url.searchParams.delete(key);
    } else {
      url.searchParams.set(key, value);
    }
    history.pushState({}, '', url.href)
  }

  setAccessoriesAvailability() {
    const isSelectedGate1W = this.selectedVariants.some(variant => variant.name === '1W Gate');
    const isSelectedGate2W = this.selectedVariants.some(variant => variant.name === '2W Gate');
    const isSlelectedFence = this.selectedVariants.some(variant => variant.name === 'Fence');
    
    this.additionalAccesories.forEach(checkboxAccesories => {
      const accessoriesFor = checkboxAccesories.getAttribute('data-for');
      const dataPost = checkboxAccesories.getAttribute('data-post');

      if (accessoriesFor.includes('1wgate') && accessoriesFor.includes('2wgate')) {
        const isDisabled = !isSelectedGate1W && !isSelectedGate2W;
        const wasChecked = checkboxAccesories.checked;

        checkboxAccesories.disabled = isDisabled;

        if (wasChecked && isDisabled) {
          checkboxAccesories.checked = false;
          checkboxAccesories.dispatchEvent(new Event('change'));
        }

        return;
      };

      if ((accessoriesFor.includes('1wgate'))) {
        const isDisabled = !isSelectedGate1W;
        const wasChecked = checkboxAccesories.checked;

        checkboxAccesories.disabled = !isSelectedGate1W;

        if (wasChecked && isDisabled) {
          checkboxAccesories.checked = false;
          checkboxAccesories.dispatchEvent(new Event('change'));
        }
      }

      if ((accessoriesFor.includes('2wgate'))) {
        checkboxAccesories.disabled = !isSelectedGate2W;
        const wasChecked = checkboxAccesories.checked;

        if (wasChecked && !isSelectedGate2W) {
          checkboxAccesories.checked = false;
          checkboxAccesories.dispatchEvent(new Event('change'));
        }
      }

      if ((accessoriesFor.includes('fence'))) {
        checkboxAccesories.disabled = !isSlelectedFence;
        const wasChecked = checkboxAccesories.checked;

        if (wasChecked && !isSlelectedFence) {
          checkboxAccesories.checked = false;
          checkboxAccesories.dispatchEvent(new Event('change'));
        }
      }

      if (dataPost) {
        checkboxAccesories.disabled = this.selectedPfosten !== dataPost;
        const wasChecked = checkboxAccesories.checked;
        if (wasChecked && checkboxAccesories.disabled) {
          checkboxAccesories.checked = false;
          checkboxAccesories.dispatchEvent(new Event('change'));
        }
      }
    });
  }

  initInfoPopup(overlaySelector, modalSelector, closeIconSelector, triggerSelector) {
    const overlay = document.querySelector(overlaySelector);
    const modal = document.querySelector(modalSelector);
    const closeIcon = document.querySelector(closeIconSelector);
    const triggers = document.querySelectorAll(triggerSelector);
  
    if (overlay && modal && closeIcon && triggers.length) {
      const showModal = (triggerEl) => {
        modal.style.display = 'block';
        overlay.style.display = 'block';
  
        if (typeof slate?.a11y?.trapFocus === 'function') {
          slate.a11y.trapFocus({ container: modal });
        }
  
        modal._triggerEl = triggerEl;
  
        document.addEventListener('keydown', escHandler);
      };
  
      const hideModal = () => {
        modal.style.display = 'none';
        overlay.style.display = 'none';
  
        if (typeof slate?.a11y?.removeTrapFocus === 'function') {
          slate.a11y.removeTrapFocus({ container: modal });
        }
  
        if (modal._triggerEl) {
          modal._triggerEl.focus();
          modal._triggerEl = null;
        }
  
        document.removeEventListener('keydown', escHandler);
      };
  
      const escHandler = (e) => {
        if (e.key === 'Escape') {
          hideModal();
        }
      };
  
      triggers.forEach(trigger => {
        trigger.addEventListener('click', () => {
          showModal(trigger);
        });
  
        trigger.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            showModal(trigger);
          }
        });
      });
  
      closeIcon.addEventListener('click', hideModal);
  
      closeIcon.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          hideModal();
        }
      });
  
      overlay.addEventListener('click', hideModal);
    }
  }
}

customElements.define("fence-builder-new", FenceBuilderNew);